import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth-context";

/** Post-checkout landing: Stripe's success_url is /ops?welcome=1 — greet the new subscriber
 *  once, confirm the seat is active, and scrub the query param so refreshes stay clean. */
export function WelcomeGate() {
  const { me, refreshMe } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("welcome") !== "1") return;
    setOpen(true);
    // The webhook usually lands before Stripe redirects, but refresh anyway so the profile
    // (plan/status/subscription) is current the moment the popup shows.
    void refreshMe();
    params.delete("welcome");
    const qs = params.toString();
    window.history.replaceState(null, "", window.location.pathname + (qs ? `?${qs}` : ""));
  }, [refreshMe]);

  if (!open) return null;

  return (
    <div className="fb-backdrop" style={{ zIndex: 85 }} onClick={() => setOpen(false)}>
      <div className="fb-modal" onClick={(e) => e.stopPropagation()}>
        <div className="fb-head"><span className="t">SUBSCRIPTION ACTIVE</span></div>
        <div className="fb-body">
          <p className="fb-thanks">
            Seat locked in{me?.email ? <> for <b>{me.contactEmail ?? me.email}</b></> : null} — your rate stays yours
            for as long as you keep it. The desk is live below; alerts, the ideas board and billing
            live under your account menu.
          </p>
          <button className="auth-btn primary" onClick={() => setOpen(false)}>OPEN THE DESK</button>
        </div>
      </div>
    </div>
  );
}
